import { useContext } from 'react';
import { ArrayEntityReferenceControlContext } from '../../array-entity-reference-control/array-entity-reference-provider.component';

export const useEntityReferenceControlContext = () => {
  const ctx = useContext(ArrayEntityReferenceControlContext);
  return ctx;
};
